import { Phone } from "lucide-react";
import { BRAND } from "../lib/constants";

export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${BRAND.phoneTel}`}
      data-testid="sticky-call-button"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-[color:var(--isa-gold)] text-[color:var(--isa-navy)] font-sans font-semibold text-sm uppercase tracking-[0.08em] px-5 py-3 rounded-full shadow-[0_18px_40px_-15px_rgba(212,175,55,0.65)] hover:bg-[color:var(--isa-gold-bright)] hover:-translate-y-0.5 transition-all"
      aria-label={`Call ${BRAND.phone}`}
    >
      <span className="relative inline-flex">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[color:var(--isa-gold-bright)] opacity-60 animate-ping" />
        <Phone className="w-4 h-4 relative" strokeWidth={2} />
      </span>
      <span className="hidden sm:inline">Call {BRAND.phone}</span>
      <span className="sm:hidden">Call Now</span>
    </a>
  );
};

export default StickyCallButton;
